import { DefaultService } from "@/api/SolarCloudApi";
import { OpenAPI } from "@/api/SolarCloudApi/core/OpenAPI";
import { useProfileContext } from "@/contexts/ProfileContext";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getIdToken } from "@/util/authentication";

export default function getUserQueryOptions() {
  return queryOptions({
    queryKey: ["user"],
    queryFn: getUser,
    retry: false,
    staleTime: 1000 * 60 * 60 * 4, // 4 hours
  });
}

async function getUser() {
  const token = await getIdToken();
  OpenAPI.TOKEN = token;
  const response = await DefaultService.getProfile();
  return response;
}

type UseUserOptions = {
  queryConfig?: QueryConfig<typeof getUserQueryOptions>;
};

export function useUser({ queryConfig }: UseUserOptions = {}) {
  const profile = useProfileContext();

  const queryConfigWithAuth = {
    ...queryConfig,
    enabled: !!profile.authentication?.loggedIn,
  };

  return useQuery({
    ...getUserQueryOptions(),
    ...queryConfigWithAuth,
  });
}
